const autoNgTemplateLoaderTemplate1 = require('./edgeStacksDatatable.html');

import angular from 'angular';

angular.module('shbdeployer.edge').component('edgeStacksDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'GenericDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    removeAction: '<',
    refreshCallback: '<',
  },
});
